import { u as L } from "./usePopoverIndex-b3a93ecd.mjs";
import { u as V } from "./useQuantum-50e8fd44.mjs";
import { u as Q } from "./useClient-0bbce34e.mjs";
import { u as w } from "./useSlots-a1aa6a84.mjs";
import { U as C, f as W, o as B, c as G, d as X, a as Y, e as Z, b as _ } from "./useSlots-a1aa6a84.mjs";
import { useState as h, useRef as m, useEffect as g, useCallback as x } from "react";
import { g as b, a as E, i as v } from "./isClient-ec947a14.mjs";
import { u as ee } from "./useMediaQuery-2533ee8a.mjs";
import { u as se } from "./useSize-a56c9e53.mjs";
import { u as oe } from "./useWindowSize-88e90e04.mjs";
import "@fcamna/shared-component-foundations";
const U = (t, e) => {
  const [r, s] = h(null), n = m(null), c = m(null), l = m(e);
  g(() => {
    l.current = e;
  }, [e]), g(() => {
    var u;
    const o = b(t);
    if (!o)
      return;
    const a = o.querySelectorAll(
      'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    a != null && a.length && (a[0] !== n.current && ((u = a[0]) == null || u.focus()), n.current = a[0], c.current = a[a.length - 1], s(a));
  });
  const p = (o) => {
    var i, S;
    if (!b(t) || o.code !== "Tab")
      return;
    const u = o.target === n.current, f = o.target === c.current;
    u && o.shiftKey ? (o.preventDefault(), (i = c.current) == null || i.focus()) : f && !o.shiftKey && (o.preventDefault(), (S = n.current) == null || S.focus());
  }, d = (o) => {
    var f;
    const a = o.target === n.current, u = o.target === c.current;
    (f = l == null ? void 0 : l.current) == null || f.call(l, {
      ...o,
      target: o.target,
      isFirstFocusedElement: a,
      isLastFocusedElement: u
    });
  };
  return w("keydown", p, t), w("focusin", d, t), r;
}, k = {
  attributes: !0,
  characterData: !0,
  childList: !0,
  subtree: !0
}, N = (t, e = E ? window.document : void 0, r = {}, s = "all") => {
  const n = m(t), c = m(E && v("MutationObserver")), [l, p] = h([]);
  return g(() => {
    n.current = t;
  }, [t]), g(() => {
    if (!c.current)
      return;
    const d = b(e);
    if (!d)
      return;
    const o = new MutationObserver((u, f) => {
      var S;
      const i = {
        isAdded: u.some((O) => O.addedNodes.length > 0),
        isRemoved: u.some((O) => O.removedNodes.length > 0),
        isUpdated: !1
      };
      i.isUpdated = !i.isAdded && !i.isRemoved, (s === "all" || s === "onAdd" && i.isAdded || s === "onRemove" && i.isRemoved || s === "onUpdate" && i.isUpdated) && (p(u), (S = n.current) == null || S.call(n, u, f, i));
    }), a = { ...k, ...r };
    return o.observe(d, a), () => o.disconnect();
  }, [e, r, s]), l;
}, T = (t, e, r = "mousedown") => {
  const s = m(e);
  g(() => {
    s.current = e;
  }, [e]);
  const n = x(
    (c) => {
      if (!s.current || c.defaultPrevented)
        return;
      [].concat(t).every((p) => {
        const d = b(p);
        return d && !d.contains(c.target);
      }) && s.current(c);
    },
    [t]
  );
  w(r, e ? n : void 0);
};
class y {
  constructor() {
    this.storageData = {};
  }
  get length() {
    return Object.keys(this.storageData).length;
  }
  key(e) {
    const r = Object.keys(this.storageData);
    return e >= 0 && e < r.length ? r[e] : null;
  }
  getItem(e) {
    return this.storageData[e] || null;
  }
  setItem(e, r) {
    this.storageData[e] = JSON.stringify(r);
  }
  removeItem(e) {
    delete this.storageData[e];
  }
  clear() {
    this.storageData = {};
  }
}
const I = (t, e, r) => {
  const s = r.getItem(t);
  return s !== null ? JSON.parse(s) : e;
}, D = (t, e, r) => {
  const [s, n] = h(() => I(t, e, r));
  return g(() => {
    if (s === void 0)
      return r.removeItem(t);
    r.setItem(t, JSON.stringify(s));
  }, [t, s, r]), [s, n];
}, z = (t, e) => D(t, e, E && v("localStorage") ? window == null ? void 0 : window.localStorage : new y()), H = (t, e) => D(t, e, E && v("sessionStorage") ? window == null ? void 0 : window.sessionStorage : new y());
export {
  C as UseSlotsPickType,
  W as createSlots,
  B as overflownDefaults,
  Q as useClient,
  w as useEventListener,
  U as useFocusTrap,
  G as useIsMounted,
  z as useLocalStorage,
  ee as useMediaQuery,
  N as useMutationObserver,
  T as useOnClickOutside,
  X as useOverFlown,
  L as usePopoverIndex,
  V as useQuantum,
  Y as useResizeObserver,
  Z as useScroll,
  H as useSessionStorage,
  se as useSize,
  _ as useSlots,
  D as useStorage,
  oe as useWindowSize
};
